<kp-map-modal>
    <section class="column">
        <h3>{{ mutatable.properties.type }}</h3>
        <input #fileUpload style="display: none" type="file" (change)="addImg($event.target)" />
        <input #name placeholder="Name" [(ngModel)]="mutatable.properties.name" (blur)="mutate()" [disabled]="true" />
        <div class="row">
            <input
                #url
                placeholder="Background image…"
                (click)="fileUpload.click()"
                (keydown.enter)="fileUpload.click()"
                value="{{ mutatable?.properties?.backgroundImageFileName || '' }}"
            />
            <button class="icon" (click)="removeImage()" (keydown.enter)="removeImage()">
                <img [src]="icons.del" />
            </button>
            <button class="icon" (click)="fileUpload.click()" (keydown.enter)="fileUpload.click()">
                <img [src]="icons.image" />
            </button>
        </div>
        <br />
        <div class="row flex-end">
            <!-- <button class="danger" (click)="requestRemove()" (keydown.enter)="requestRemove()">Remove from map</button> -->
            <button (click)="requestCancel()" (keydown.enter)="requestCancel()">Cancel</button>
            <button class="primary" (click)="requestOK()" (keydown.enter)="requestOK()">OK</button>
        </div>
    </section>
</kp-map-modal>
